import React from 'react';

function Publications() {

  return (
    <div className="publications">
    <div className="post">
      <h2 className="title">Signal amplification in growth cone gradient sensing by a double negative feedback loop among PTEN, PI(3,4,5)P3 and actomyosin</h2>
      <div className="date">August 31, 2022 | NIH</div>
      <p>
      Xiong Li<sup>1</sup> , Sangwoo Shim <sup>2</sup>, Katherine R Hardin <sup>3</sup>, Kiran G Vanaja <sup>4</sup>, Hongjun Song <sup>5</sup>, Andre Levchenko <sup>4</sup>, Guo-Li Ming <sup>5</sup>, James Q Zheng <sup>6</sup>
      </p>
      <a href='https://pubmed.ncbi.nlm.nih.gov/36055521/' target="_blank"><button className="button">Link→</button></a>
    </div>

    <div className="post">
      <h2 className="title">Regulation of PTEN translation by PI3K signaling maintains pathway homeostasis</h2>
      <div className="date">February 18, 2021 | NIH</div>
      <p>
      Radha Mukherjee <sup>1</sup>, Kiran G Vanaja <sup>2</sup>, Jacob A Boyer <sup>1</sup>, Sunyana Gadal <sup>1</sup>, Hilla Solomon <sup>1</sup>, Sarat Chandarlapaty <sup>3</sup>, Andre Levchenko <sup>4</sup>, Neal Rosen <sup>5</sup>
      </p>
      <a href='https://pubmed.ncbi.nlm.nih.gov/33606974/' target="_blank"><button className="button">Link→</button></a>
    </div>

    <div className="post">
      <h2 className="title">A Loss of Epigenetic Control Can Promote Cell Death through Reversing the Balance of Pathways in a Signaling Network</h2>
      <div className="date">September 20, 2018 | NIH</div>
      <p>
      Kiran G Vanaja <sup>1</sup>, Winston Timp <sup>2</sup>, Andrew P Feinberg <sup>3</sup>, Andre Levchenko <sup>4</sup>
      </p>
      <a href='https://pubmed.ncbi.nlm.nih.gov/30244832/' target="_blank"><button className="button">Link→</button></a>
    </div>

    <div className="post">
      <h2 className="title">Systems Biology of Cancer Metastasis</h2>
      <div className="date">August 28, 2019 | NIH</div>
      <p>
      Yasir Suhail<sup>1,2,ξ</sup>, Margo P. Cain<sup>3,ξ</sup>, Kiran Vanaja Gireesan<sup>2</sup>, Paul A. Kurywchak<sup>3</sup>, Andre Levchenko <sup>2</sup> Raghu Kalluri <sup>3</sup> and Kshitiz<sup>1,2,*</sup>
      </p>
      <a href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6716621/' target="_blank"><button className="button">Link→</button></a>
    </div>

    <div className="post">
      <h2 className="title">Two interferon-independent double-stranded RNA-induced host defense strategies suppress the common cold virus at warm temperature</h2>
      <div className="date">July 26, 2016 | NIH</div>
      <p>
      Ellen F Foxman <sup>1</sup>, James A Storer <sup>2</sup>, Kiran Vanaja <sup>3</sup>, Andre Levchenko <sup>3</sup>, Akiko Iwasaki <sup>4</sup>
      </p>
      <a href='https://pubmed.ncbi.nlm.nih.gov/27402752/' target="_blank"><button className="button">Link→</button></a>
    </div>
  </div>
  );
}

export default Publications;
